module.exports = __webpack_public_path__ + "img/jiaoyu_disijunyidaxue_suoluetu.ea797120.png";